import { action, observable } from 'mobx'
// Request
import { FeedbackCommentRequest } from '../requests/FeedbackCommentRequest'

class FeedbackCommentStore {
  @observable pageIndex = 0
  @observable pageSize = 10
  @observable totalCount = 0
  @observable queryParamsSignDocument = {
    page: 0,
    size: 10,
    title: null,
    status: null,
    from_date: null,
    to_date: null,
  }

  @action clearQueryParamsIncoming = () => {
    this.queryParamsSignDocument = {
      page: 0,
      size: 10,
      title: null,
      status: null,
      from_date: null,
      to_date: null,
    }
  }

  @observable feedbackCommentData = []
  @observable feedbackCommentDataDetail = []
  @observable feedbackCommentDataDetailV2 = []
  @observable fileNameData = []
  @observable feedbackDetailData = {}
  @observable feedbackDetailDataById = {}
  @observable countAllUser = 0
  @observable countAgree = 0
  @observable countDisAgree = 0
  @observable countOther = 0
  @observable feedbackDetailDataV2 = {}

  @action setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  @action clearElectronicDocumentList = () => {
    this.electronicDocumentList.length = 0
  }
  @action clearSelectedElectronicDocument = () => {
    this.selectedElectronicDocument = {}
  }

  @action clearFilter = () => {
    this.pageIndex = 0
    this.pageSize = 10
    this.totalCount = 0
  }

  @action setQueryParamsSignDocument = payload => {
    this.queryParamsSignDocument = payload
  }

  @action getFeedbackCommentListByProcedureId = id => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.getFeedbackCommentListByProcedureId(id)
        .then(response => {
          this.feedbackCommentData = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getFeedbackCommentById = id => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.getFeedbackCommentById(id)
        .then(response => {
          this.feedbackCommentDataDetailV2 = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getDetailFeedbackByCommentIdAndUsername = params => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.getDetailFeedbackByCommentIdAndUsername(params)
        .then(response => {
          this.feedbackCommentDataDetail = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createElectronicDocument = dataSubmit => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.createFeedbackProcedure(dataSubmit)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getFeedbackCommentByIdV2 = code => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.getFeedbackCommentByIdV2(code)
        .then(response => {
          this.feedbackDetailDataById = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateComment = (data, code) => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.createFeedbackComment(data, code)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateVotingStatus = (code, data) => {
    return new Promise((resolve, reject) => {
      FeedbackCommentRequest.updateFeedbackCommentDetail(code, data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action clearFeedbackDetailDataById = () => {
    this.feedbackDetailDataById = {}
  }
}

export default new FeedbackCommentStore()
